import Vue from 'vue'

const queryBuilder = {
    buildFilterPattern(field) {
        let columns = [
            {
                "id": field.nKey,
                "isSystem": true
            }
        ];
        let filter = {
            "not": false,
            "rules": [],
            "valid": true,
            "dialect": "Postgresql",
            "condition": "AND",
            "spatialFilters": [],
            "select": columns,
            "tables": [],
            "relationships": [],
            "multiTables": true
        };
        return filter;
    },
    buildLayerPattern(gdIdEvent, gdIdParent, layerName, expressions, rowCount = 0) {
        let query = {
            "Postgresql": expressions.Postgresql,
            "Geoserver": expressions.Geoserver
        };
        let layerPattern = {
            "gdIdEvent": gdIdEvent,
            "gdIdParent": gdIdParent,
            "cAccount": "DataAccessWebAPI",
            "nIdEnvironment": Vue.prototype.$foundation.getEnvironmentId(),
            "cClientTag": Vue.prototype.$foundation.getEnvironmentName(),
            "cUser": Vue.prototype.$foundation.getCurrentUser(),
            "cTag": Vue.prototype.$foundation.getUniqueId(),
            "cTick": "?",
            "cAlias": layerName,
            "bStarred": false,
            "cClass": "filter",
            "jbQuery": {query: query},
            "jbData": {
                "config": {
                    "schema": "default",
                    "table": "PJ_ATIVA_2020",
                    "enable": false,
                    "shared": false,
                    "source": "Filtro Empresas",
                    "source2": null,
                    "datavis": {
                        "type": "circle",
                        "label": {
                            "enabled": false
                        },
                        "style": {
                            "fillColor": "#51bbd6",
                            "borderColor": "#000000",
                            "borderWidth": 0,
                            "fillOpacity": 0.7,
                            "borderOpacity": 1
                        },
                        "native": "circle",
                        "origin": "circle",
                        "symbol": {
                            "enabled": false
                        },
                        "autoAggMode": {
                            "type": "system",
                            "value": false,
                            "aggType": -99
                        },
                        "maxFeatures": 100000,
                        "featureCount": 0
                    },
                    "rowCount": {
                        "rowCount": rowCount,
                        "dateCount": new Date(Date.now()).toLocaleDateString("pt-BR"),
                        "featureCount": rowCount
                    },
                    "tag": [{
                        "name": "Empresas",
                        "color": "#4286f4"
                    }, {
                        "name": "Filtro",
                        "color": "#0f3675"
                    }
                    ],
                    "primaryKey": "cnpj",
                    "isFilterCognatis": false
                }
            }
        }
        console.log('Layer Pattern')
        console.log(layerPattern)
        return layerPattern;
    },
    buildStaticJoinCondition() {
        return {
            "id": "?",
            "type": "integer",
            "input": "text",
            "value": 0,
            "operator": "greater",
            "spatial": false
        };
    },
    searchSpatialRelations(rules) {
        let lsSptRelations = []
        let _this = this
        rules.forEach(function (item) {
            if (item.rules != undefined && item.rules != null && item.rules.length != 0) {

                let ret = []
                ret = _this.searchSpatialRelations(item.rules)
                if (ret.length > 0) {
                    ret.forEach(function (iret) {
                        lsSptRelations.push(iret)
                    })
                }

            } else {

                if (item.id == 'geom') {
                    let ret = []
                    ret = item.spatialFilters
                    if (ret.length > 0) {
                        ret.forEach(function (iret) {
                            lsSptRelations.push(iret)
                        })
                    }

                }
            }
        })
        return lsSptRelations
    },
    removeSpatialColumnsOnRules(rules) {
        let newGroup = []
        let newRules = []
        let _this = this
        rules.forEach(function (item) {
            if (item.rules != undefined && item.rules != null && item.rules.length != 0) {
                let ret = []
                ret = _this.removeSpatialColumnsOnRules(item.rules)
                if (ret.length > 0) {
                    ret.forEach(function (iret) {
                        newRules.push(iret)
                    })
                }

            } else {
                if (item.id != 'geom') {
                    newRules.push(item)
                }
            }
        })
        return newRules
    },
    prepareExpressions(rules) {
        if (rules.operator == 'distance') {
            rules.operator = rules.secundaryOperator
        }
        return rules
    },
    buildMetadata(rules, tables, withGeometry = false, mainOperator = 'AND') {
        if (!rules) {
            console.error('Esperado o objeto: rules');
            return;
        }
        if (!tables) {
            console.error('Esperado o objeto: tables');
            return;
        }

        this.resolveBetweenOperator(rules);
        let bMultiTable = false;
        let relationships = [];
        let _columns = [];
        let _tables = [];
        let _this = this;
        if (this.isJoinTables(tables)) {
            bMultiTable = true;
            tables.relationship.forEach(function (item) {
                relationships.push(item);
            })
        }

        let lsSptRelations = _this.searchSpatialRelations(rules)
        console.log('Build meta data 2')
        lsSptRelations.forEach(function (item) {
            relationships.push(item);
        })
        console.log('Build meta data 3')
        //removendo Grupos, removido temporariamente
        //let newRules = _this.removeSpatialColumnsOnRules(rules)

        let newRules = rules
        console.log("old Rules")
        console.log(newRules)

        for (let i = 0; i < newRules.length; i++) {
            console.log(newRules[i])
            newRules[i].field = ""
            if (newRules[i].rules !== undefined) {

                for (let j = 0; j < newRules[i].rules.length; j++) {
                    console.log('sub Rules')
                    console.log(newRules[i].rules[j])
                    newRules[i].rules[j].field = ""
                }
            }
        }
        console.log("New Rules")
        console.log(newRules)

        console.log('Build meta data 4')
        tables.selected.forEach(function (table, index) {
            _tables.push(
                {
                    uid: table.uid,
                    alias: table.alias || "",
                    schema: table.schema || "default",
                    name: table.table,
                    billing: table.billing,
                    tableIndex: table.index
                });
            console.log('Build meta data 5')
            table.columns.selected.forEach(function (column) {
                if (column != undefined)
                    _columns.push({
                        schema: table.schema || "default",
                        table: column.table || table.table,
                        tableIndex: column.tableIndex || table.index,
                        field: column.field || column.name,
                        alias: column.alias,
                        geometry: column.hasOwnProperty("field") ? column.field === "geom" : column.name === "geom"
                    })
            })
        });

        if (withGeometry === true && _columns.find(x => x.geometry === true) === undefined) {
            const geom = this.getGeometryColumn(tables);
            if (geom) _columns.push(geom)
        }

        let metadata = {
            "condition": mainOperator,
            "dialect": "Postgresql",
            "spatialFilters": [],
            "select": _columns,
            "tables": _tables,
            "rules": newRules,
            "not": false,
            "valid": true,
            "multiTables": bMultiTable,
            "relationships": relationships.length == 0 ? tables.relationship : relationships
        };

        console.log(JSON.stringify(metadata));

        return metadata;
    },
    buildMetadataPurchase(allTables, activeTables, selectedColumns, relationshipColumn) {
        //region Validations
        if (!(Array.isArray(allTables))) {
            console.error('"allTables" deve ser um objeto: "Array"')
            return;
        }
        if (allTables.length <= 0) {
            console.warn('Nenhuma tabela foi selecionada')
            return;
        }
        if (!(Array.isArray(activeTables))) {
            console.error('"activeTables" deve ser um objeto: "Array"')
            return;
        }
        if (activeTables.length <= 0) {
            console.warn('Nenhuma tabela foi selecionada')
            return;
        }
        if (!(selectedColumns instanceof Map)) {
            console.error('"selectedColumns" deve ser um objeto: "Map"')
            return;
        }
        if (selectedColumns.size <= 0) {
            console.warn('Nenhuma coluna foi selecionada')
            return;
        }
        if (relationshipColumn.length <= 0) {
            console.warn('Esperada a coluna de relacionamento')
            return;
        }
        //endregion

        try {
            const dbSchema = "default";
            const hasJoin = selectedColumns.size > 1;
            let relationships = new Map();
            let columns = [];
            let internalTables = [];
            let relationships2 = [];
            let index = 0;
            let _this = this;

            //Prepare columns
            for (const [k, v] of selectedColumns) {
                relationships.set(index, {table: k, column: relationshipColumn});
                internalTables.push({
                    schema: dbSchema,
                    table: k,
                    index: index
                });
                v.forEach(function (column) {
                    columns.push(
                        {
                            schema: column.schema || dbSchema,
                            "table": k,
                            "tableIndex": index,
                            "field": column.name,
                            "alias": column.alias,
                            "geometry": column.name === "geom"
                        });
                });
                index++;
            }

            index = 0;

            //Prepare JOINS
            if (hasJoin) {
                //let mainTable = "";
                let relationalKey1 = "";
                let metaTable, baseTable;
                for (const [k, v] of relationships) {
                    if (k == 0) {
                        relationalKey1 = _this.getRelationshipKey({
                            tables: allTables,
                            table: v.table,
                            column: v.column
                        });
                        metaTable = allTables.find(t => t.schema == dbSchema && t.table == v.table);
                        baseTable = activeTables.find(t => t.schema == dbSchema && t.table == v.table);
                    }

                    let nextIdx = k + 1;
                    let nextValue = relationships.get(nextIdx);

                    if (nextValue) {
                        let relationalKey2 = _this.getRelationshipKey({
                            tables: allTables,
                            table: nextValue.table,
                            column: v.column
                        });
                        let metaTable2 = allTables.find(t => t.schema == dbSchema && t.table == nextValue.table);
                        let nextTable = activeTables.find(t => t.schema == dbSchema && t.table == nextValue.table);

                        relationships2.push({
                            "joinType": nextTable.join || "INNER JOIN",
                            "joinConditions": [],
                            "tables": [
                                {
                                    "field": relationalKey1.name,
                                    "layer": {
                                        "id": metaTable.layer,
                                        "name": metaTable.name
                                    },
                                    "table": v.table,
                                    "schema": metaTable.schema
                                },
                                {
                                    "field": relationalKey2.name,
                                    "layer": {
                                        "id": metaTable2.layer,
                                        "name": metaTable2.name
                                    },
                                    "table": nextValue.table,
                                    "schema": metaTable2.schema
                                }
                            ]
                        });
                    }
                    index++;
                }
            }

            return {
                "condition": "AND",
                "dialect": "Postgresql",
                "spatialFilters": [],
                "select": columns,
                "tables": internalTables,
                "rules": {},
                "not": false,
                "valid": true,
                "multiTables": hasJoin,
                "relationships": relationships2
            };
        } catch (e) {
            console.log(`Erro ao preparar o metadado para compra: ${e}`)
        }
    },
    buildRelationship(field) {
        return {
            "joinType": "JOIN",
            "spatial": false,
            "joinConditions": [
                {
                    "condition": "AND",
                    "rules": new Array(this.buildStaticJoinCondition())
                }
            ],
            "tables": []
        };
    },
    getGeometryColumn(tables, tableName) {
        if (tableName) {
            let t = tables.selected.find(x => x.table = tableName);
            if (!t) return;
            let g = t.columns.all.find(x => x.name = "geom");
            if (!g) return;
            return {
                "schema": t.schema || "default",
                "table": t.table,
                "tableIndex": tables.selected.indexOf(t),
                "field": g.field,
                "alias": g.alias || "Geometria",
                "geometry": true
            }
        } else {
            for (var i = 0; i < tables.selected.length; i++) {
                for (var j = 0; j < tables.selected[i].columns.all.length; j++) {
                    if (tables.selected[i].columns.all[j].name == "geom") {
                        return {
                            "schema": tables.selected[i].schema || "default",
                            "table": tables.selected[i].table,
                            "tableIndex": i,
                            "field": tables.selected[i].columns.all[j].name || "geom",
                            "alias": tables.selected[i].columns.all[j].alias || "Geometria",
                            "geometry": true
                        }
                    }
                }
            }
        }
    },
    getRelationshipKey: function (args) {
        if (!args) return;
        if (!args.table) return;
        if (!args.column) return;
        let _column = undefined;

        try {
            args.tables.forEach(function (table) {
                table.columns.forEach(function (column) {
                    if (column.table === args.table &&
                        (column.alias.toLowerCase() === args.column.toLowerCase() ||
                            column.name.toLowerCase() === args.column.toLowerCase())) {
                        _column = column;
                    }
                });
            });
        } catch (e) {
            console.log(`Erro ao recuperar a coluna relacional`)
        }

        if (!_column) return;
        return _column;
    },
    isJoinTables(tables) {
        if (!tables) {
            console.error('Esperado o objeto: tables')
            return;
        }
        let tableCount = tables.selected.length;
        let relationshipTableCount = 0;

        if (tables.relationship) {
            tables.relationship.forEach(function (relationship) {
                relationshipTableCount += relationship.tables.length;
            })
        }
        return (tableCount > 1 || relationshipTableCount > 1);
    },
    resolveBetweenOperator: function (data) {
        if (!data || !Array.isArray(data)) {
            console.error('Esperado um array de elementos')
            return;
        }
        for (var i = 0; i < data.length; i++) {
            if (data[i].rules === undefined) continue;
            if (data[i].rules.length != 0) this.resolveBetweenOperator(data[i].rules)
            if (data[i].value === undefined) continue;
            if (!Array.isArray(data[i].value))
                data[i].value = data[i].valueB == null ? data[i].value : new Array(data[i].value, data[i].valueB)
            if (data[i].id == 'geom') {
                data[i] = this.prepareExpressions(data[i])
            }
        }
    }
};

export default queryBuilder;
